import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type DeleteProgramMemberBody = {
  data: Array<{
    /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
    entity_ids: string[];
    entity_type: 'Program';
    roles: string[];
    user_id: string;
    /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
  }>;
};

type DeleteProgramMemberRouteParams = {
  programId: string;
  userId: string;
};

export const deleteProgramMember = async ({
  body,
}: BodyRouteParamsRequest<DeleteProgramMemberBody, DeleteProgramMemberRouteParams>) =>
  apiClient.patch<unknown, ApiClientResponse<unknown>>(routes.community.changeRole, body);
